import { Building2 } from 'lucide-react';

import { page, type DeclarationModule } from '@/app/moduleRegistry';

/**
 * Declaration du module Platform.
 *
 * `toujoursActif` : ce module ignore `ModuleActivation`. Sans lui, une entreprise
 * ayant desactive tous ses modules perdrait l'ecran qui permet de les reactiver —
 * un cul-de-sac dont on ne sortirait qu'en base de donnees.
 */
export const modulePlatform: DeclarationModule = {
  id: 'platform',
  libelle: 'Mon entreprise',
  icone: Building2,
  ordre: 100,
  toujoursActif: true,

  routes: [
    {
      chemin: 'entreprise',
      estAccueil: true,
      libelleNav: 'Mon entreprise',
      dansParametres: true,
      composant: page(() => import('./pages/EntreprisePages')),
    },
    {
      chemin: 'entreprise/choisir',
      composant: page(async () => ({
        default: (await import('./pages/EntreprisePages')).ChoisirEntreprisePage,
      })),
    },
    {
      chemin: 'entreprise/nouvelle',
      composant: page(async () => ({
        default: (await import('./pages/EntreprisePages')).NouvelleEntreprisePage,
      })),
    },
    {
      chemin: 'modules',
      libelleNav: 'Modules',
      dansParametres: true,
      composant: page(() => import('./pages/ModulesPage')),
    },
    {
      chemin: 'equipe',
      libelleNav: 'Equipe',
      dansParametres: true,
      composant: page(() => import('./pages/EquipePage')),
    },
    {
      chemin: 'abonnement',
      libelleNav: 'Abonnement',
      dansParametres: true,
      composant: page(() => import('./pages/AbonnementPage')),
    },
  ],
};
